export const environment = {
  name: 'prod',
  production: true,
  local: false,
  isThreeStats: false,
  baseUri: 'http://goodloading-server.service.aws-eu-west-1.sdp.dev.goodloading.com/api/',
  googleClientId: '855032181768-4fcplepp0r4be18uqgsvlh9iqe8eav6h.apps.googleusercontent.com',
  facebookClientId: '1112950095943022',
  transClientId: '35780e42-390c-488f-8aa6-56814b4998c8',
  transUrl: 'https://auth.platform.rc.trans.eu/',
  sentry: 'https://b7dfc268c67a49fc9aebd8c660a78470@sentry.io/279931',
  ipinfo: '0322614b20c7c4',
};
